var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightroomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#425c77",
    className: "adobe-icon-svg",
    d: "M200.33.18H39.39C17.53.18-.28,17.99-.28,39.95v154.28c0,21.96,17.81,39.77,39.66,39.77h161.05c21.85,0,39.66-17.81,39.55-39.77V39.84C239.99,17.99,222.29.18,200.33.18ZM125,148.07l-2.5,14.19c-.2.8-.7,1.2-1.5,1.2h-54.56v-.1c-1.2,0-1.5-.5-1.5-1.5V54.44c0-.8.3-1.3,1.2-1.3h15.79c.8,0,1,.3,1,1.2v92.53h41.17c.8,0,1.1.3.9,1.2ZM179.66,96.11c0,.8-.3,1-1.2,1-6.3-.3-15.59.5-19.09,2v63.05c0,.8-.3,1.2-1.2,1.2h-15.69c-.8,0-1.2-.3-1.2-1.2v-63.55h.1c0-1.2,0-4.1-.5-9.69,0-.8.2-1,.8-1.3,6.1-2.5,20.58-6.89,36.77-6.89.8,0,1.2.2,1.2,1v14.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightroomIcon);
export default __webpack_public_path__ + "static/media/lightroom-icon.7824367a7dbd193f5dbf6262a6a39883.svg";
export { ForwardRef as ReactComponent };